"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@bhdzllr/tabs");
var OebbAutocomplete_1 = require("../lib/OebbAutocomplete");
var OebbDialogModal_1 = require("../lib/OebbDialogModal");
var PoiMap_1 = require("../poi-map/PoiMap");
var GridSize;
(function (GridSize) {
    GridSize[GridSize["Large"] = 0] = "Large";
    GridSize[GridSize["Medium"] = 1] = "Medium";
    GridSize[GridSize["Small"] = 2] = "Small";
})(GridSize || (GridSize = {}));
var UMLAUT_MAP = {
    ä: 'ae',
    ö: 'oe',
    ü: 'ue',
    ß: 'ss',
};
var nav = document.querySelector('.js-nav');
var pages = document.querySelectorAll('.js-page');
var pageLinks = document.querySelectorAll('.js-page-link');
var pageNames = [];
var loaderOverlay = document.querySelector('.js-loader-overlay');
var loaderStation = document.querySelector('.js-loader-station');
var shopFilterForm = document.querySelector('.js-shop-filter-form');
var shopsCategorized = document.querySelectorAll('[data-shop-category]');
var favouritesToggle = document.querySelector('.js-station-search-favourites-toggle');
var stationSearchToggle = document.querySelector('.js-station-search-toggle');
var stationSearch = document.querySelector('.js-station-search');
var stationSearchForm = document.querySelector('.js-station-search-form');
var stationSearchField = document.querySelector('.js-station-search-field');
var stationSearchFieldList = document.querySelector('.js-station-search-field-list');
var stationSearchFieldEmptyResult = document.querySelector('.js-station-search-field-empty-result');
var stationSearchFieldEmptyFavourites = document.querySelector('.js-station-search-field-empty-favourites');
var stations = [];
var stationsGrouped = [];
var stationsGroupedFavourites = [];
var stationAutocomplete;
var resizeObserver;
var gridInitialized = false;
var isStationSearchOpen = false;
var isFavouritesActive = false;
var umlautMap = {};
var umlautRegex;
function main() {
    initSettings();
    initDom();
    initListeners();
    collectStations();
    createStationSearchField();
    initEmptySelectButton();
}
function initSettings() {
    umlautMap = __assign({}, UMLAUT_MAP);
    umlautRegex = new RegExp("".concat(Object.keys(umlautMap).join('|')), 'g');
}
function initDom() {
    document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/, 'js');
    (0, OebbDialogModal_1.addOebbDialogModalDefaultStyles)();
    (0, OebbDialogModal_1.initDialogsModalWithTemplate)();
    if (pages.length === 0 || pageLinks.length === 0) {
        return;
    }
    pages.forEach(function (page) {
        pageNames.push(page.id);
    });
    pageLinks.forEach(function (pageLink) {
        pageLink.addEventListener('click', function (e) {
            e.preventDefault();
            setActivePage(e.target.href.split('#')[1]);
        });
    });
    stationSearchField.value = '';
    resizeObserver = new ResizeObserver(function (entries) {
        var gridContainer = entries.at(0);
        var inlineSize = gridContainer.borderBoxSize[0].inlineSize;
        if (inlineSize >= 1200 && !gridContainer.target.classList.contains('js-grid-container-lg')) {
            gridContainer.target.classList.remove('js-grid-container-md');
            gridContainer.target.classList.add('js-grid-container-lg');
            updateGrid(gridContainer.target, GridSize.Large);
        }
        else if (inlineSize < 1200 && inlineSize >= 744 && !gridContainer.target.classList.contains('js-grid-container-md')) {
            gridContainer.target.classList.remove('js-grid-container-lg');
            gridContainer.target.classList.add('js-grid-container-md');
            updateGrid(gridContainer.target, GridSize.Medium);
        }
        else if (inlineSize < 744) {
            gridContainer.target.classList.remove('js-grid-container-lg');
            gridContainer.target.classList.remove('js-grid-container-md');
            updateGrid(gridContainer.target, GridSize.Small);
        }
    });
    resizeObserver.observe(document.querySelector('.js-grid-container'));
    setActivePage();
    addStencil();
    addPopover();
}
function afterGridInitialized() {
    gridInitialized = true;
    (0, PoiMap_1.initPoiMaps)(nav);
}
function initListeners() {
    stationSearchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (isStationSearchOpen) {
            hideStationSearch(this);
        }
        else {
            showStationSearch(this);
        }
    });
    stationSearchForm.addEventListener('submit', function (e) {
        e.preventDefault();
    });
    stationSearchForm.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            hideStationSearch(stationSearchToggle);
        }
    });
    favouritesToggle.addEventListener('change', function (e) {
        e.preventDefault();
        if (this.checked) {
            showFavourites();
        }
        else {
            hideFavourites();
        }
    });
    shopFilterForm === null || shopFilterForm === void 0 ? void 0 : shopFilterForm.addEventListener('change', function (e) {
        e.preventDefault();
        filterShops(e.target);
    });
}
function initEmptySelectButton() {
    var button = document.querySelector('.js-itg-empty-select-button');
    if (!button)
        return;
    button.addEventListener('click', function () {
        stationSearchToggle.click();
    });
}
function addStencil() {
    if (document.querySelector('#js-oebb-corp-2016-stencil'))
        return;
    var script = document.createElement('script');
    script.src = '/.resources/corp-2016/themes/stencil/corp-2016/corp-2016.esm.js';
    script.type = 'module';
    script.id = 'js-oebb-corp-2016-stencil';
    document.body.appendChild(script);
}
function addPopover() {
    if (document.querySelector('#js-oebb-popover'))
        return;
    var script = document.createElement('script');
    script.src = '/.resources/corp-2016/themes/js/Popover.js';
    script.type = 'module';
    script.id = 'js-oebb-popover';
    document.body.appendChild(script);
    var popovers = document.querySelectorAll('oebb-popover');
    popovers.forEach(function (popover) {
        popover.setAttribute('fullsm', '');
    });
}
function setActivePage(newPageName) {
    var pageName = newPageName !== null && newPageName !== void 0 ? newPageName : pageLinks[0].href.split('#')[1];
    var nextActivePage;
    var nextAcitvePageLink;
    pages.forEach(function (page) {
        page.classList.remove('page--active');
        if (page.id === pageName) {
            nextActivePage = page;
        }
    });
    pageLinks.forEach(function (pageLink) {
        pageLink.classList.remove('nav__active');
        if (pageLink.href.split('#')[1] === pageName) {
            nextAcitvePageLink = pageLink;
        }
    });
    nextActivePage.classList.add('page--active');
    nextAcitvePageLink.classList.add('nav__active');
    window.scrollTo(0, 0);
}
function collectStations() {
    var listEls = stationSearchFieldList.querySelectorAll('li');
    for (var i = 0; i < listEls.length; i++) {
        var li = listEls[i];
        stations.push({
            plc: li.dataset.plc,
            title: li.textContent.trim(),
        });
    }
    stationsGrouped.push.apply(stationsGrouped, getStationsGroupedFromStations(stations));
    stationSearchFieldList.innerHTML = '';
}
function getStationsGroupedFromStations(stations) {
    var stationsGrouped = [];
    var _loop_1 = function (i) {
        var station = stations[i];
        var letter = Array.from(station.title)[0].toLowerCase();
        var group = stationsGrouped.find(function (group) { return group.letter === letter; });
        if (!group) {
            group = {
                letter: letter,
                stations: [],
            };
            stationsGrouped.push(group);
        }
        group.stations.push({
            plc: station.plc,
            title: station.title,
        });
    };
    for (var i = 0; i < stations.length; i++) {
        _loop_1(i);
    }
    return stationsGrouped;
}
function createStationSearchField() {
    var getAutocompleteItem = function (plc, title, label) {
        var favourites = getFavourites();
        return "\n\t\t\t<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\" data-plc=\"".concat(plc, " \"data-title=\"").concat(title, "\">\n\t\t\t\t<div class=\"autocomplete-item\">\n\t\t\t\t\t<span>").concat(label, "</span>\n\t\t\t\t\t<button class=\"favourite ").concat(favourites.has(plc) ? 'favourite--active' : '', " js-favourite\" data-plc=\"").concat(plc, "\">\n\t\t\t\t\t\t<span class=\"screen-reader-text\">Zu Favoriten hinzuf\u00FCgen</span>\n\t\t\t\t\t\t<svg width=\"18\" height=\"17\" viewBox=\"0 0 18 17\">\n\t\t\t\t\t\t\t<path id=\"star\" fill=\"#999999\" d=\"M5.84994 13.825L8.99994 11.925L12.1499 13.85L11.3249 10.25L14.0999 7.85L10.4499 7.525L8.99994 4.125L7.54994 7.5L3.89994 7.825L6.67494 10.25L5.84994 13.825ZM3.57499 16.9615L5.00767 10.7923L0.221191 6.64425L6.53652 6.0962L8.99994 0.27895L11.4634 6.0962L17.7787 6.64425L12.9922 10.7923L14.4249 16.9615L8.99994 13.6884L3.57499 16.9615Z\" />\n\t\t\t\t\t\t\t<path id=\"star-fill\" fill=\"#737373\" d=\"M3.57499 16.9615L5.00767 10.7923L0.221191 6.64425L6.53652 6.0962L8.99994 0.278954L11.4634 6.0962L17.7787 6.64425L12.9922 10.7923L14.4249 16.9615L8.99994 13.6884L3.57499 16.9615Z\" />\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t");
    };
    stationSearchFieldList.addEventListener('click', function (e) {
        var target = e.target;
        var favouriteButton = target.closest('.js-favourite');
        if (favouriteButton) {
            e.stopImmediatePropagation();
            var plc = favouriteButton.dataset.plc;
            var favourites = getFavourites();
            if (!favourites.has(plc)) {
                favourites.add(plc);
                favouriteButton.classList.add('favourite--active');
                favouriteButton.classList.add('favourite--activate');
            }
            else {
                favourites.delete(plc);
                favouriteButton.classList.remove('favourite--active');
                favouriteButton.classList.add('favourite--deactivate');
            }
            localStorage.setItem('favourites', JSON.stringify(Array.from(favourites)));
        }
    });
    stationAutocomplete = new OebbAutocomplete_1.OebbAutocomplete(stationSearchField, stationSearchFieldList)
        .withTemplate(function (groupOrStation) {
        var value = this.input.value.toLowerCase();
        if ('letter' in groupOrStation) {
            return "\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<span class=\"autocomplete-letter\">".concat(groupOrStation.letter, "</span>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t").concat(groupOrStation.stations
                .map(function (station) {
                var valueStartIndex = station.title.toLowerCase().indexOf(value);
                var valueEndIndex = valueStartIndex + value.length;
                var titleMarkup = station.title;
                if (value.length > 0 && !station.transliterated) {
                    if (valueStartIndex === 0) {
                        titleMarkup = "".concat(titleMarkup.substring(0, valueEndIndex), "<strong>").concat(titleMarkup.substring(valueEndIndex), "</strong>");
                    }
                    else {
                        titleMarkup = "<strong>".concat(titleMarkup.substring(0, valueStartIndex), "</strong>").concat(titleMarkup.substring(valueStartIndex, valueEndIndex), "<strong>").concat(titleMarkup.substring(valueEndIndex), "</strong>");
                    }
                }
                return getAutocompleteItem(station.plc, station.title, titleMarkup);
            })
                .join(''), "\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</li>\n\t\t\t\t");
        }
        else {
            var valueStartIndex = groupOrStation.title.toLowerCase().indexOf(value);
            var valueEndIndex = valueStartIndex + value.length;
            var titleMarkup = groupOrStation.title;
            if (value.length > 0) {
                if (valueStartIndex === 0) {
                    titleMarkup = "".concat(titleMarkup.substring(0, valueEndIndex), "<strong>").concat(titleMarkup.substring(valueEndIndex, value.length), "</strong>");
                }
                else {
                    titleMarkup = "<strong>".concat(titleMarkup.substring(0, valueStartIndex), "</strong>").concat(titleMarkup.substring(valueStartIndex, valueEndIndex), "<strong>").concat(titleMarkup.substring(valueEndIndex, value.length), "</strong>");
                }
            }
            return getAutocompleteItem(groupOrStation.plc, groupOrStation.title, titleMarkup);
        }
    })
        .onKeyup(function () {
        var value = this.getValue();
        var groupsFiltered = [];
        (!isFavouritesActive ? stationsGrouped : stationsGroupedFavourites).forEach(function (group) {
            var letter = group.letter;
            var stations = [];
            group.stations.forEach(function (station) {
                if (station.title.toLowerCase().includes(value.toLowerCase())) {
                    station.transliterated = false;
                    stations.push(station);
                }
                else if (transliterate(station.title).includes(value.toLowerCase()) ||
                    transliterate(station.title).includes(transliterate(value.toLowerCase()))) {
                    station.transliterated = true;
                    stations.push(station);
                }
            });
            if (stations.length > 0) {
                groupsFiltered.push({
                    letter: letter,
                    stations: stations,
                });
            }
        });
        stationSearchFieldList.hidden = false;
        stationSearchFieldEmptyResult.hidden = true;
        if (value && groupsFiltered.length > 0) {
            // Search input and filtered result
            this.setData(groupsFiltered);
        }
        else if (value && groupsFiltered.length === 0) {
            // Search input, but no result
            this.setData([]);
            stationSearchFieldList.hidden = true;
            stationSearchFieldEmptyResult.hidden = false;
        }
        else {
            // Empty field, show all stations grouped
            this.setData(!isFavouritesActive ? stationsGrouped : stationsGroupedFavourites);
        }
    })
        .onItemActive(function (index) {
        this.setValue(this.getItems()[index].dataset.title);
    })
        .onItemSelect(function (index) {
        var item = this.getItems()[index];
        this.setValue(item.dataset.title);
        goToNextStation(item.dataset.plc.trim(), item.dataset.title.trim());
    })
        .withPanelAlwaysOpen()
        .withScrollSpaceTop(52)
        .withFirstItemOnEnter();
    stationAutocomplete.setData(stationsGrouped);
    stationAutocomplete.render();
}
function transliterate(text) {
    return text.toLowerCase().replace(umlautRegex, function (match) { return umlautMap[match]; });
}
function showStationSearch(button) {
    isStationSearchOpen = true;
    button.disabled = true;
    button.textContent = button.dataset.textClose;
    stationSearch.classList.add('station-search--open');
    document.documentElement.style.overflowY = 'hidden';
    setTimeout(function () {
        stationSearchField.focus();
        button.disabled = false;
    }, 500);
}
function hideStationSearch(button) {
    isStationSearchOpen = false;
    button.disabled = true;
    button.textContent = button.dataset.textOpen;
    stationSearch.classList.remove('station-search--open');
    document.documentElement.style.overflowY = 'auto';
    setTimeout(function () {
        button.disabled = false;
    }, 500);
}
function getFavourites() {
    try {
        return new Set(JSON.parse(localStorage.getItem('favourites')));
    }
    catch (e) {
        return new Set();
    }
}
function showFavourites() {
    var favourites = getFavourites();
    var favouriteStations = stations.filter(function (station) { return favourites.has(station.plc); });
    var favouriteStationsGrouped = getStationsGroupedFromStations(favouriteStations);
    stationsGroupedFavourites.length = 0;
    stationsGroupedFavourites.push.apply(stationsGroupedFavourites, favouriteStationsGrouped);
    isFavouritesActive = true;
    stationAutocomplete.setData(stationsGroupedFavourites);
    stationAutocomplete.setValue('');
    stationAutocomplete.render();
    if (stationsGroupedFavourites.length === 0) {
        stationSearchFieldEmptyFavourites.hidden = false;
    }
    else {
        stationSearchFieldEmptyFavourites.hidden = true;
    }
}
function hideFavourites() {
    isFavouritesActive = false;
    stationAutocomplete.setData(stationsGrouped);
    stationAutocomplete.setValue('');
    stationAutocomplete.render();
    stationSearchFieldEmptyFavourites.hidden = true;
}
function goToNextStation(plc, title) {
    setTimeout(function () { return stationSearchField.blur(); }); // Timeout blur to not trigger Autocomplete blur too early
    loaderOverlay.hidden = false;
    loaderStation.textContent = title;
    window.location.href = generateUrl(plc);
}
function generateUrl(plc) {
    var url = new URL(window.location.href);
    url.hash = '';
    if (url.pathname.match(/~.*~/)) {
        url.pathname = url.pathname.replace(/~.*~/, '~' + plc + '~');
    }
    else {
        url.pathname += "~".concat(plc, "~");
    }
    return url.toString();
}
function updateGrid(gridContainer, size) {
    var gridSm = gridContainer.querySelector('.js-grid-sm');
    var gridMd = gridContainer.querySelector('.js-grid-md');
    var gridLg = gridContainer.querySelector('.js-grid-lg');
    var pages = gridContainer.querySelectorAll('.js-page');
    var pagesByPriority = Array.from(pages).sort(function (a, b) {
        if (a.dataset.priority > b.dataset.priority)
            return -1;
        if (a.dataset.priority < b.dataset.priority)
            return 1;
        return 0;
    });
    if (size === GridSize.Small) {
        gridSm.hidden = false;
        gridMd.hidden = true;
        gridLg.hidden = true;
        pagesByPriority.forEach(function (page) {
            gridSm.append(page);
        });
    }
    if (size === GridSize.Medium) {
        gridSm.hidden = true;
        gridMd.hidden = false;
        gridLg.hidden = true;
        if (pagesByPriority.length === 3) {
            gridMd.classList.add('grid-md--span');
        }
        pagesByPriority.forEach(function (page) {
            switch (page.id) {
                case 'abfahrt':
                    gridMd.querySelector('.js-grid-md-dep').append(page);
                    break;
                case 'ankunft':
                    gridMd.querySelector('.js-grid-md-arr').append(page);
                    break;
                case 'baustellen':
                case 'info-buchung':
                case 'bildergalerie':
                case 'lageplan':
                    gridMd.querySelector('.js-grid-md-left').append(page);
                    break;
                case 'bahnhofsausstattung':
                case 'mobilitaetsangebot':
                case 'shopping-kulinarik':
                    gridMd.querySelector('.js-grid-md-right').append(page);
                    break;
            }
        });
    }
    if (size === GridSize.Large) {
        gridSm.hidden = true;
        gridMd.hidden = true;
        gridLg.hidden = false;
        pagesByPriority.forEach(function (page) {
            switch (page.id) {
                case 'abfahrt':
                    gridLg.querySelector('.js-grid-lg-dep').append(page);
                    break;
                case 'ankunft':
                    gridLg.querySelector('.js-grid-lg-arr').append(page);
                    break;
                case 'bahnhofsausstattung':
                case 'mobilitaetsangebot':
                    gridLg.querySelector('.js-grid-lg-left').append(page);
                    break;
                case 'bildergalerie':
                case 'lageplan':
                    if (pagesByPriority.length === 3) {
                        gridLg.querySelector('.js-grid-lg-right').append(page);
                    }
                    else {
                        gridLg.querySelector('.js-grid-lg-center').append(page);
                    }
                    break;
                case 'baustellen':
                case 'info-buchung':
                case 'shopping-kulinarik':
                    gridLg.querySelector('.js-grid-lg-right').append(page);
                    break;
            }
        });
    }
    if (!gridInitialized) {
        afterGridInitialized();
    }
}
function filterShops(target) {
    if (target.dataset.category === 'all') {
        shopsCategorized.forEach(function (shopCategorized) {
            shopCategorized.hidden = false;
        });
        setTimeout(function () { return target.focus(); });
        return;
    }
    shopsCategorized.forEach(function (shopCategorized) {
        if (target.dataset.category === shopCategorized.dataset.shopCategory) {
            shopCategorized.hidden = false;
        }
        else {
            shopCategorized.hidden = true;
        }
    });
    setTimeout(function () { return target.focus(); });
}
main();
